import { useLazyQuery } from '@apollo/client/react';
import { useSetAtom } from 'jotai';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

import { GetMedixsPatientDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';
import { patientDetailDialogState } from '~/state/partials/patient_detail_dialog/atoms';

export const useOpenMedixsPatientDialog = (eventId?: number, recommendationPresetCode?: string) => {
  const setPatientDetailDialogState = useSetAtom(patientDetailDialogState);
  const router = useRouter();
  const [getMedixsPatient] = useLazyQuery(GetMedixsPatientDocument, {
    fetchPolicy: 'network-only',
  });

  const open = useCallback(
    async (patientCode: string, pharmacyId: string) => {
      if (!patientCode) return;

      const result = await getMedixsPatient({
        variables: {
          patientCode,
        },
      });

      const _data = result.data;
      if (_data) {
        const medixsSetting = getMe(_data)?.organization.medixsSetting;
        const medixsPatient = medixsSetting?.medixsPatients?.nodes[0];
        if (medixsSetting?.active && medixsPatient?.pharmacyId === pharmacyId) {
          setPatientDetailDialogState((state) => ({
            ...state,
            isOpen: true,
            patientId: medixsPatient.patient?.id || medixsPatient.guestPatients?.[0]?.id,
            eventId: eventId || null,
            recommendationPresetCode: recommendationPresetCode || null,
          }));
        }
        await router.replace({ pathname: router.pathname, query: {} });
      }
    },
    [eventId, getMedixsPatient, recommendationPresetCode, router, setPatientDetailDialogState],
  );

  return { open };
};
